/**
 * Formats an ISO-8601 timestamp string into a locale-specific date/time string.
 * Returns the raw timestamp if parsing fails.
 */
export const formatTimestamp = (timestamp: string): string => {
    const date = new Date(timestamp);
    return Number.isNaN(date.getTime()) ? timestamp : date.toLocaleString();
};
